import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import App from "./App";
import Loader from "./app/components/Loader";
import { storeImageViewer } from "./app/redux/reducers/authSlice";
import { RootState } from "./app/redux/store";
import ImageViewer from "react-simple-image-viewer";

const MainApp = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)

    return (
        <React.Fragment>
            {
                auth.activityIndicator && (
                    <Loader />
                )
            }

            {
                auth.imageViewer.length > 0 && (
                    <ImageViewer
                        src={auth.imageViewer}
                        currentIndex={0}
                        onClose={() => dispatch(storeImageViewer([]))}
                        disableScroll={false}
                        backgroundStyle={{
                            backgroundColor: "rgba(0,0,0,0.66)",
                            zIndex: 99999
                        }}
                        closeOnClickOutside={true}
                    />
                )
            }

            <App />
        </React.Fragment>
    )
}

export default MainApp;